
import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Box,
  Button,
  Paper,
  TableSortLabel,
  InputAdornment,
  Link,
  List,
  ListItemButton,
  ListItemText,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import { format } from "date-fns";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Export from "../../../assests/images/export.svg";

import { debounce } from "lodash";
import { KeyboardArrowDown, KeyboardArrowUp, Search } from "@mui/icons-material";
import FilterPopup from "../../../pages/reports/RetailersReports/FilterPopup";
import DatePicker from "react-datepicker";
import CalendorIcon from "../../../assests/images/calendar-2.svg";
import { viewretailers, uploadcsv, getExportRetailers } from "../api";
import { getToken } from "../../../utils/utils";
import PaginationComponent from "../../brands/Pagination";
import Plus from "../../../../src/assests/images/Plus.svg";
import { relative } from "path/win32";

// Data Types
export interface FilterPopupProps {
  filter: any;
  page: number;
  limit: number;
  debouncedSearchTerm: string;
}

interface User {
  userId: string;
  PMIEntityCode: string | null;
  retailer_name: string | null;
  outlet_name: string | null;
  locations: string | null;
  outlet_type: string | null;
  member_Since: string;
  remaining_points: string;
  total_points: string;
  TotalTaskCompleted: number;
  lastLogin: string;
}

type SortKey = keyof User | null; // Allow null for no sorting

// Main Table Component
const Retailerreports = ({ filter }: any) => {
  const [selectedFilters, setSelectedFilters] = useState<{
    locations: string[];
    outletTypes: string[];
    lastlogin: string[];
  }>({ locations: [], outletTypes: [], lastlogin: [] });

  const handleApplyFilters = (filters: { locations: string[]; outletTypes: string[]; lastlogin: string[] }) => {
    console.log(filters, "filtersdddddddddddeeee");
    setSelectedFilters(filters);
    setIsPopupVisible(false);
  };

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [sortConfig, setSortConfig] = useState<{
    key: SortKey;
    order: "asc" | "desc";
  }>({ key: null, order: "asc" }); // No default sorting
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [retailersData, setRetailersData] = useState<User[]>([]);
  const token = getToken();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [retailerscount, setretailerscount] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);
  const limit = 10;

  // Column selection state
  const allColumns = [
    "User ID",
    "PMI Entity Code",
    "Retailer’s Name",
    "Outlet Name",
    "Location",
    "Outlet Type",
    "Member Since",

    "Points",
    "Current Points",
    "Phone Number",
    "Tasks Given",
    "Total Lifetime Points",
    "Total Redeemed Points",
    "Last Redemption Date",
    "Tasks Completed",
    "Current Active Tasks",
    "Current Active Tasks Completed",
    "Last Login Date"
  ];

  const columnKeyMap: Record<string, keyof User | string> = {
    "User ID": "userId",
    "PMI Entity Code": "PMIEntityCode",
    "Retailer’s Name": "retailer_name",
    "Outlet Name": "outlet_name",
    "Location": "locations",
    "Outlet Type": "outlet_type",
    "Member Since": "member_Since",
    // "Total Task Completed": "TotalTaskCompleted",
    // "Points": "total_points",
    "Phone Number": "phone_number",
    "Current Points": "Current_points",


    "Tasks Given": "Tasks_given",
    "Total Lifetime Points": "Total_lifetime_points",
    "Total Redeemed Points": "Total_Redeemed_Points",
    "Last Redemption Date": "Last_redeemption_date",
    "Tasks Completed": "Tasks_completed",
    "Current Active Tasks": "Current_active_tasks",
    "Current Active Tasks Completed": "Current_active_tasks_completed",
    "Last Login Date": "last_login",


  };

  const [visibleColumns, setVisibleColumns] = useState<string[]>(allColumns.slice(0, 6));
  const hiddenColumns = allColumns.filter((col) => !visibleColumns.includes(col));

  useEffect(() => {
    const debouncedSearch = debounce((value) => {
      setDebouncedSearchTerm(value);
    }, 500);

    debouncedSearch(searchTerm);
    return () => debouncedSearch.cancel();
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsPopupVisible(false);
      }
    };

    if (isPopupVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupVisible]);

  const sortedData = useMemo(() => {
    if (!sortConfig.key) {
      return retailersData; // Return unsorted data if no sort key
    }

    return [...retailersData].sort((a, b) => {
      const key = sortConfig.key as keyof User; // Non-null assertion since key is checked
      const aValue = a[key];
      const bValue = b[key];

      // Handle null values
      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return sortConfig.order === "asc" ? 1 : -1;
      if (bValue == null) return sortConfig.order === "asc" ? -1 : 1;

      // Handle numerical fields
      if (key === "remaining_points" || key === "total_points") {
        const aNum = parseFloat(aValue as string) || 0;
        const bNum = parseFloat(bValue as string) || 0;
        return sortConfig.order === "asc" ? aNum - bNum : bNum - aNum;
      }

      // Handle date fields
      if (key === "member_Since" || key === "lastLogin") {
        const aDate = new Date(aValue as string);
        const bDate = new Date(bValue as string);
        const aTime = isNaN(aDate.getTime()) ? 0 : aDate.getTime();
        const bTime = isNaN(bDate.getTime()) ? 0 : bDate.getTime();
        return sortConfig.order === "asc" ? aTime - bTime : bTime - aTime;
      }

      // Handle number field
      if (key === "TotalTaskCompleted") {
        const aNum = aValue as number; // Type assertion: TotalTaskCompleted is number
        const bNum = bValue as number; // Type assertion: TotalTaskCompleted is number
        return sortConfig.order === "asc" ? aNum - bNum : bNum - aNum;
      }

      // Handle string fields (including userId)
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.order === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }

      return 0;
    });
  }, [retailersData, sortConfig]);


  console.log(sortedData, "sortedDatasortedDatasortedData");
  console.log(retailersData, "retailersDataretailersDataretailersData");

  const togglePopup = () => {
    setIsPopupVisible((prev) => !prev);
  };

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupPosition, setPopupPosition] = useState<number>(0);
  const [selectedlastlogin, setSelectedlastlogin] = useState<string[]>([]);

  const sortButtonRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const startDate = dateRange[0];
  const endDate = dateRange[1];

  useEffect(() => {
    if (sortButtonRef.current && isPopupOpen) {
      const buttonRect = sortButtonRef.current.getBoundingClientRect();
      setPopupPosition(buttonRect.bottom);
    }
  }, [isPopupOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node) &&
        !sortButtonRef.current?.contains(event.target as Node)
      ) {
        setIsPopupOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const formatDate = (date: Date | null) =>
        date ? format(date, "dd MMM yyyy") : "";

      const reqBody = {
        locations: selectedFilters.locations,
        outlet_type: selectedFilters.outletTypes,
        lastLogin:
          selectedTab === 2 && selectedFilters.lastlogin?.length
            ? selectedFilters.lastlogin.join(",")
            : "",
        search: debouncedSearchTerm || "",
        page: String(page),
        limit: String(limit),
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
      };

      try {
        const response = await viewretailers(reqBody, token);

        const mappedData = response.data.data.finaluser_tasks.map((item: any) => ({
          userId: item.userId,
          PMIEntityCode: item.pmi_entity_code,
          retailer_name: item.retailer_name,
          outlet_name: item.outlet_name,
          locations: item.locations,
          outlet_type: item.outlet_type,
          member_Since: item.member_Since,
          TotalTaskCompleted: Number(item.no_of_task),
          last_login: item.last_login,
          remaining_points: item["remaining_points/total_points"].split("/")[0],
          total_points: item["remaining_points/total_points"].split("/")[1],
          phone_number: item.phone_number,
          Current_points: item.Current_points,
          Tasks_given: item.Tasks_given,
          Total_lifetime_points: item.Total_lifetime_points,
          Total_Redeemed_Points: item.Total_Redeemed_Points,
          Last_redeemption_date: item.Last_redeemption_date,
          Tasks_completed: item.Tasks_completed,
          Current_active_tasks: item.Current_active_tasks,
          Current_active_tasks_completed: item.Current_active_tasks_completed,







        }));

        setRetailersData(mappedData);
        setretailerscount(response.data.data.retalers_length);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [token, debouncedSearchTerm, selectedFilters, page, limit, startDate, endDate]);



  const handleExportClick = async () => {
    try {


      const formatDate = (date: Date | null) =>
        date ? format(date, "dd MMM yyyy") : "";

      const response = await getExportRetailers(
        {
          locations: selectedFilters.locations,
          outlet_type: selectedFilters.outletTypes,
          lastLogin:
            selectedTab === 2 && selectedFilters.lastlogin?.length
              ? selectedFilters.lastlogin.join(",")
              : "",
          search: debouncedSearchTerm || "",
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),



        },
        token // pass your token here
      );

      // Convert response to a Blob and trigger download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `retailers_${new Date().toISOString().split("T")[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error exporting XLSX:", error);
    }
  };



  const perpagedata = 10;
  const totalpages = Math.ceil(retailerscount / perpagedata);

  const handleSort = (key: SortKey) => {
    setSortConfig((prev) => ({
      key,
      order: prev.key === key && prev.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleColumnSelect = (col: string) => {
    if (visibleColumns.includes(col)) return;
    const updated = [...visibleColumns.slice(1), col];
    setVisibleColumns(updated);
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      try {
        const response = await uploadcsv(file);
        console.log("Upload successful", response);
      } catch (error) {
        console.error("Error uploading CSV:", error);
      }
    }
  };

  return (
    <Box sx={{ background: "#fff", paddingTop: "30px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 32px",
          background: "#fff",
        }}
      >
        <Box sx={{ background: "#fff", width: "100%" }}>
          <Box sx={{ display: "flex" }}>
            <Link
              href="#"
              sx={{
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "500",
                color: "rgba(105, 106, 107, 1)",
                paddingRight: "10px",
              }}
            >
              Retailers List
            </Link>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "16px" }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#000",
              }}
            >
              Retailers List
            </Typography>
            <Link
              sx={{
                borderRadius: "8px",
                padding: "14px 16px",
                color: "#FFF",
                textDecoration: "none",
                background: "rgba(200, 23, 47, 1)",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none",
                cursor: "pointer",
              }}
            >
              <Link onClick={handleUploadClick} sx={{ cursor: "pointer", display: "flex", alignItems: "center", color: "#fff" }}>
                <img style={{ marginRight: "8px" }} src={Plus} alt="Plus" />
                Upload CSV
              </Link>
              <input
                type="file"
                accept=".csv"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </Link>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
          padding: "0 32px 30px",
        }}
      >
        <Box sx={{ maxWidth: "520px", flexGrow: 1 }}>
          <TextField
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              ".MuiOutlinedInput-root": {
                border: "none",
                background: "#FFF",
                color: "rgba(167, 168, 169, 1)",
                borderRadius: "12px",
                height: "48px",
                width: "521px",
                fontSize: "16px",
                fontWeight: "500",
                margin: "10px 0 0px",
                "& input::placeholder": {
                  color: "rgba(167, 168, 169, 1)",
                  opacity: 1,
                },
              },
              fontSize: "14px",
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "2px solid #F5F5F5",
                },
                "&:hover fieldset": {
                  borderColor: "#000",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#000",
                },
              },
            }}
            placeholder="Search by Reports, Pmi Entity Code, Retailer Name, Outlet Name, Locations"
            type="search"
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search
                    sx={{
                      background: "#FFFFFF00",
                      height: "30px",
                      width: "20px",
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ marginRight: "8px", width: "301px" }}>
            <DatePicker
              selectsRange={true}
              startDate={startDate || undefined}
              endDate={endDate || undefined}
              onChange={(update) => setDateRange(update)}
              customInput={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    padding: "0 10px",
                    height: "48px",
                    boxSizing: "border-box",
                    width: "301px",
                  }}
                >
                  <input
                    value={
                      startDate && endDate
                        ? `${startDate.toLocaleDateString()} to ${endDate.toLocaleDateString()}`
                        : "1 Sep 2024 to 15 Dec 2024"
                    }
                    style={{
                      fontSize: "14px",
                      border: "none",
                      outline: "none",
                      flex: 1,
                      color: "#000",
                      backgroundColor: "transparent",
                    }}
                    readOnly
                  />
                  <img
                    src={CalendorIcon}
                    alt="Calendar Icon"
                    style={{
                      height: "20px",
                      width: "20px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              }
            />
          </Box>
        </Box>
      </Box>

      {isPopupOpen && (
        <Box
          ref={popupRef}
          sx={{
            position: "absolute",
            top: `${popupPosition + 10}px`,
            right: "30px",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px 0",
            zIndex: 999,
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            width: "320px",
          }}
        >
          <List>
            {["Highest to Lowest Points", "Lowest Points to Highest Points"].map((text, index) => (
              <ListItemButton
                key={index}
                component="li"
                sx={{
                  "&:hover": {
                    background: "#EEF4FF",
                    color: "#000",
                  },
                }}
                onClick={() => {
                  setSortConfig({
                    key: "total_points",
                    order: index === 0 ? "desc" : "asc",
                  });
                  setIsPopupOpen(false);
                }}
              >
                <ListItemText primary={text} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      )}

      <Box
        sx={{
          width: "100%",
          background: "#f9fbfc",
          padding: "20px 30px",
          borderTop: "1px solid #d3d3d3",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#FFF",
            borderRadius: "12px 12px 0 0",
            border: "1px solid #d3d3d3",
          }}
        >
          <Box>
            <Typography
              variant="h6"
              sx={{ fontSize: "16px", fontWeight: "600", marginLeft: "16px" }}
            >
              Total {retailerscount} Users
            </Typography>
          </Box>
          <Select
            displayEmpty
            value=""
            onChange={(e) => handleColumnSelect(e.target.value)}
            renderValue={() => "Select Column"}
            sx={{
              minWidth: 240,
              height: "48px",
              borderRadius: "10px",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              marginRight: "8px",
            }}
          >
            {hiddenColumns.map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
          <Box>
            <Button
              variant="contained"
              ref={buttonRef}
              onClick={togglePopup}
              sx={{
                textTransform: "capitalize",
                backgroundColor: "#fff",
                marginTop: "20px",
                marginBottom: "20px",
                height: "44px",
                padding: "7px 12px",
                borderRadius: "4px",
                color: "#565656",
                border: "1px solid #DEDEDE",
                boxShadow: "none",
                marginRight: "20px",
                "&:hover": { backgroundColor: "#fff" },
              }}
              endIcon={<ExpandMoreIcon sx={{ fontSize: "30px" }} />}
            >
              Filters
            </Button>

            <Button
              variant="contained"
              sx={{
                textTransform: "capitalize",
                backgroundColor: "#fff",
                fontSize: "14px",
                fontWeight: "500",
                position: "relative",
                left: "-7px",
                height: "40px",
                padding: "16px",
                borderRadius: "10px",
                color: "#C8172F",
                border: "1px solid #C8172F",
                boxShadow: "none",
                "&:hover": {},
                "& .MuiButton-endIcon": {
                  fontSize: "30px",
                  color: "var(--Icon-Colour, #C8172F)",
                },
                "&:before, &:after": {
                  border: "none",
                },
              }}
              startIcon={<img src={Export} alt="export"></img>}
              onClick={() => handleExportClick()}
            >
              Export CSV
            </Button>

            {isPopupVisible && (
              <div ref={popupRef}>
                <FilterPopup
                  filter={{}}
                  onApplyFilters={handleApplyFilters}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  setSelectedlastlogin={setSelectedlastlogin}
                  selectedlastlogin={selectedlastlogin}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                />
              </div>
            )}
          </Box>
        </Box>
        <TableContainer sx={{ border: "1px solid #d3d3d3" }} component={Paper}>
          <Table>
            <TableHead
              sx={{
                background: "#EEF4FF",
                "& .MuiTableSortLabel-icon": {
                  opacity: "1 !important",
                },
              }}
            >
              <TableRow>
                {visibleColumns.map((col) => (
                  <TableCell key={col}>
                    <TableSortLabel
                      active={sortConfig.key === columnKeyMap[col]}
                      direction={sortConfig.key === columnKeyMap[col] ? sortConfig.order : "asc"}
                      onClick={() => handleSort(columnKeyMap[col] as SortKey)}
                    >
                      {col}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData.map((row, index) => (
                <TableRow key={index}>
                  {visibleColumns.map((col) => (
                    <TableCell key={col}>
                      {col === "Points"
                        ? `${row.remaining_points}/${row.total_points}`
                        : row[columnKeyMap[col] as keyof User] || "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <PaginationComponent page={page} limit={limit} totalPages={totalpages} setPage={setPage} />
      </Box>
    </Box>
  );
};

export default Retailerreports;